import i18n from '../i18n';

function getCurrentLanguage() {
  return i18n.resolvedLanguage || i18n.language || 'en';
}

export const localizeNumber = (number, language = getCurrentLanguage()) => {
  if (language === 'ar') {
    // Force Arabic numerals with direct mapping
    const arabicNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    return number.toString().replace(/[0-9]/g, d => arabicNumerals[d]);
  }
  // For other languages, use Intl.NumberFormat

  return new Intl.NumberFormat(language, { useGrouping: false }).format(number);
};

export const localizeMonth = (dateObj, format = 'short', language = getCurrentLanguage()) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj)) {
    throw new Error('Invalid date object passed to localizeMonthYear');
  }

  // Ensure format is one of the accepted values
  const monthFormat = format === 'long' ? 'long' : 'short';

  // Use Intl.DateTimeFormat or toLocaleDateString with options
  // month: format, year: "numeric"
  const options = {
    month: monthFormat,
  };

  if (format === 'long') {
    options.year = 'numeric';
  }
  // toLocaleDateString gives month + year + possibly day depending on locale, but with these options
  // it should give only month + year
  const localized = dateObj.toLocaleDateString(language, options);

  return localized;
};
